import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { getAssetsPackage } from '../assetsPackage';
import { Endpoints, DailyBonusResponseKeys, SpinnerItemKeys } from '../../../api/Constants';
import { handleQueryLoggerEvents } from '../../sagas/handleLoggerErrorEvents';
import Logger from '../../../lib/analytics/logger';
import { validateJson } from '../../../utils/jsonschema/validator';
import { EVENT_TYPES } from '../../../lib/analytics/constants';
import transformObjectResponseKeys from '../../../utils/transformObjectResponseKeys';
import transformObjectArrayResponse from '../../../utils/transformObjectArrayResponse';
import ERROR_CODE from '../../../utils/errorCodes';
import { setDailyBonus } from '../../../state/actions/load';
export var getDailyWheelBonusQuery = {
  query: function query() {
    return {
      url: Endpoints.CLAIM_DAILY_BONUS
    };
  },
  keepUnusedDataFor: 0,
  transformResponse: function transformResponse(response) {
    return response;
  },
  onQueryStarted: function () {
    var _onQueryStarted = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data, _ref) {
      var dispatch, queryFulfilled, _response$data$, response, eventPayload;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch = _ref.dispatch, queryFulfilled = _ref.queryFulfilled;
              _context.prev = 1;
              _context.next = 4;
              return queryFulfilled;

            case 4:
              response = _context.sent;

              if (!((response === null || response === void 0 ? void 0 : (_response$data$ = response.data[0]) === null || _response$data$ === void 0 ? void 0 : _response$data$.success) === false)) {
                _context.next = 10;
                break;
              }

              dispatch(setDailyBonus(false));
              eventPayload = {
                description: "Failed to claim daily spin, ".concat(response.error),
                code: 31
              };
              Logger.sendEvent(EVENT_TYPES.ERROR_CREATED, eventPayload);
              throw Error("[Claim-Daily-Bonus-response] ".concat(response.error));

            case 10:
              _context.next = 16;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](1);
              dispatch(setDailyBonus(false));
              handleQueryLoggerEvents(_context.t0);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 12]]);
    }));

    function onQueryStarted(_x, _x2) {
      return _onQueryStarted.apply(this, arguments);
    }

    return onQueryStarted;
  }()
};
export var getDailyWheelDataQuery = {
  query: function query() {
    return {
      url: Endpoints.GET_DAILY_WHEEL_INFO
    };
  },
  keepUnusedDataFor: 0,
  transformResponse: function transformResponse(response) {
    if (!(response === null || response === void 0 ? void 0 : response[0])) return response;
    if (validateJson(Endpoints.GET_DAILY_WHEEL_INFO, response)) return response;
  },
  onQueryStarted: function () {
    var _onQueryStarted2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data, _ref2) {
      var dispatch, queryFulfilled, response, responseData, dailyWheelData, _yield$dispatch, isSuccess;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch = _ref2.dispatch, queryFulfilled = _ref2.queryFulfilled;
              _context2.prev = 1;
              _context2.next = 4;
              return queryFulfilled;

            case 4:
              response = _context2.sent;
              responseData = response === null || response === void 0 ? void 0 : response.data[0];

              if (!(responseData === false || Object.keys(responseData).length === 0 && responseData.constructor === Object)) {
                _context2.next = 9;
                break;
              }

              dispatch(setDailyBonus(false));
              return _context2.abrupt("return", false);

            case 9:
              if (!((responseData === null || responseData === void 0 ? void 0 : responseData.success) === false)) {
                _context2.next = 13;
                break;
              }

              throw Error("[Check-Daily-Bonus-response] ".concat(responseData === null || responseData === void 0 ? void 0 : responseData.error));

            case 13:
              dailyWheelData = handleResponse(responseData);

              if (dailyWheelData) {
                _context2.next = 17;
                break;
              }

              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
                code: ERROR_CODE.GET_DAILY_BONUS_FAIL
              });
              return _context2.abrupt("return", false);

            case 17:
              _context2.next = 19;
              return dispatch(getAssetsPackage.initiate({
                assetsPackageId: dailyWheelData === null || dailyWheelData === void 0 ? void 0 : dailyWheelData.ASSET_PACKAGE
              }));

            case 19:
              _yield$dispatch = _context2.sent;
              isSuccess = _yield$dispatch.isSuccess;
              isSuccess && dispatch(setDailyBonus(dailyWheelData));

            case 22:
              _context2.next = 29;
              break;

            case 24:
              _context2.prev = 24;
              _context2.t0 = _context2["catch"](1);
              dispatch(setDailyBonus(false));
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
                error: JSON.stringify(_context2.t0, Object.getOwnPropertyNames(_context2.t0)),
                code: ERROR_CODE.GET_DAILY_BONUS_FAIL
              });
              handleQueryLoggerEvents(_context2.t0);

            case 29:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 24]]);
    }));

    function onQueryStarted(_x3, _x4) {
      return _onQueryStarted2.apply(this, arguments);
    }

    return onQueryStarted;
  }()
};

var handleResponse = function handleResponse(callResponse) {
  var _callResponse$LOGIN_S;

  callResponse = transformObjectResponseKeys(callResponse, DailyBonusResponseKeys);
  callResponse.SPINNER_ITEMS = transformObjectArrayResponse(callResponse.SPINNER_ITEMS);

  for (var i = 0; i < callResponse.SPINNER_ITEMS.length; i++) {
    callResponse.SPINNER_ITEMS[i] = transformObjectResponseKeys(callResponse.SPINNER_ITEMS[i], SpinnerItemKeys);
    callResponse.SPINNER_ITEMS[i].AMOUNT = parseInt(callResponse.SPINNER_ITEMS[i].AMOUNT);
  }

  callResponse.RESPIN_COST = parseInt(callResponse.RESPIN_COST);
  callResponse.LOGIN_STREAK_COINS_LIST = transformObjectArrayResponse(callResponse.LOGIN_STREAK_COINS_LIST);
  callResponse.LOGIN_STREAK_LOYALTY_LIST = transformObjectArrayResponse(callResponse.LOGIN_STREAK_LOYALTY_LIST);
  callResponse.LOGIN_STREAK_BONUS_LIST = [];

  for (var _i = 0; _i < callResponse.LOGIN_STREAK_COINS_LIST.length; _i++) {
    var bonus = {};
    bonus.coins = parseInt(callResponse.LOGIN_STREAK_COINS_LIST[_i].amount);
    bonus.loyalty = parseInt(callResponse.LOGIN_STREAK_LOYALTY_LIST[_i].amount);
    bonus.day = parseInt(callResponse.LOGIN_STREAK_LOYALTY_LIST[_i]['__sort_key']);
    callResponse.LOGIN_STREAK_BONUS_LIST.push(bonus);
  }

  callResponse.MEMBER_TIERS = transformObjectArrayResponse(callResponse.MEMBER_TIERS);

  if (((_callResponse$LOGIN_S = callResponse.LOGIN_STREAK_BONUS_LIST) === null || _callResponse$LOGIN_S === void 0 ? void 0 : _callResponse$LOGIN_S.findIndex(function (item) {
    return item.day === callResponse.CURRENT_REWARD_DAY;
  })) < 0) {
    return false;
  }

  return callResponse;
};